import { ContextStore } from './context/context-store.state';
import { UserStore } from './user/user-store.state';

export const store = [
  UserStore,
  ContextStore
];
